define((require) => {
    "use strict";

    var EditorActivity  = require("editor/ui/experience/editor/activity/EditorActivity");

    /**
     * An activity of grouping widgets.
     *
     * @class WidgetGroupedActivity
     */
    return EditorActivity.extend({

        widgetType: "composite",

        compositeWidgets: null,
        groupWidgets: null,
        sceneModel: null,

        constructor: function(compositeWidgets, groupWidgets, sceneModel) {
            this.compositeWidgets = compositeWidgets;
            this.groupWidgets = groupWidgets;
            this.sceneModel = sceneModel;
        },

        _onUndo: function() {
            this.sceneModel.ungroupWidgets(this.compositeWidgets, {cause: "undo", activity: this});
        },

        _onRedo: function() {
            this.sceneModel.ungroupWidgets(this.groupWidgets, {cause: "redo", activity: this});
        },

        updateCompositeWidgetsReference: function(compositeWidgets) {
            this.compositeWidgets = compositeWidgets;
        },

        dispose: function() {
            this.compositeWidgets = null;
            this.groupWidgets = null;
            this.sceneModel = null;
        }

    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/editor/activity/WidgetsGroupedActivity.js